<template>
  <div class="h-search order-2 order-md-0" v-if="myItem && myItem.showroom">
    <!-- <autocomplete
      ref="autocomplete"
      method="POST"
      placeholder="What are you shopping for?"
      :source="distributionGroupsEndpoint"
      input-class="form-control"
      results-property="data"
      :results-display="formattedDisplay"
      @selected="addDistributionGroup"
    >
    </autocomplete> -->
  </div>
</template>

  <script>
import { mapActions, mapGetters } from "vuex";
import Autocomplete from "vuejs-auto-complete";
import axios from "axios";
export default {
  data() {
    return {
      searchQuery: "", // Holds the value entered in the search input
      searchResults: [], // Holds the search results to display
      minCharacters: 2, // Minimum characters required before hitting the API
      searchTimer: null, // Timer to delay API call after user input
    };
  },
  components: {
    Autocomplete,
  },
  methods: {
    distributionGroupsEndpoint(input) {
      return (
        "/api/visualization/products?page=0&qs=1&showroom=" +
        this.myItem.showroom +
        "&search=" +
        input
      );
    },
    addDistributionGroup(group) {
      let gid = group.selectedObject.id;
      window.location.href = "/product/" + this.str_encode(gid);
      this.$refs.autocomplete.clear();
    },

    formattedDisplay(result) {
      return result.product.name;
    },
  },
  computed: {
    ...mapGetters({
      category: "Common/selectedCategory",
      myItem: "Common/MyItem",
    }),
  },
};
</script>
 